export default __webpack_public_path__ + "static/media/204.200d279d.jpg";